import React from "react";

/** 단문 — 낮은 한 줄 입력 박스 */
export function ShortTextIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
            <rect x="3" y="9" width="18" height="7" rx="1.5"/>
            <path strokeLinecap="round" d="M7 12.5h7"/>
        </svg>
    );
}

/** 장문 — 높은 여러 줄 텍스트 영역 */
export function LongTextIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
            <rect x="3" y="4" width="18" height="16" rx="1.5"/>
            <path strokeLinecap="round" d="M7 8h10"/>
            <path strokeLinecap="round" d="M7 11h10"/>
            <path strokeLinecap="round" d="M7 14h10"/>
            <path strokeLinecap="round" d="M7 17h6"/>
        </svg>
    );
}

export function DateIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"/>
        </svg>
    );
}

export function UserIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"/>
        </svg>
    );
}

export function SelectIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm0 5.25h.007v.008H3.75V12Zm0 5.25h.007v.008H3.75v-.008Z"/>
        </svg>
    );
}

export const FORMAT_META = {
    INPUT: {Icon: ShortTextIcon, label: "단문"},
    TEXT: {Icon: LongTextIcon, label: "장문"},
    DATE: {Icon: DateIcon, label: "날짜"},
    USER: {Icon: UserIcon, label: "사용자"},
    SELECT: {Icon: SelectIcon, label: "선택옵션"},
};

function FieldFormatDisplay({type, groupName, showLabel = false}) {
    const meta = FORMAT_META[type];
    if (!meta) return null;

    const {Icon, label} = meta;
    const isSelect = type === "SELECT";
    const typeClass = type ? ` field-format-display--${type.toLowerCase()}` : "";

    return (
        <span
            className={`field-format-display${typeClass}${isSelect ? " field-format-display--select" : ""}${showLabel ? " field-format-display--with-label" : ""}`}
            title={isSelect && groupName ? `${label}: ${groupName}` : label}
        >
            <span className="field-format-display__icon">
                <Icon />
            </span>
            {showLabel ? (
                <span className="field-format-display__label">{label}</span>
            ) : isSelect && groupName ? (
                <span className="field-format-display__label">{groupName}</span>
            ) : null}
        </span>
    );
}

export default FieldFormatDisplay;
